import React from "react";
import styled from "styled-components";

const Error = () => {
    return (
        <>
            <ErrorMessage>통신하던 중 에러가 발생했습니다.</ErrorMessage>
        </>
    );
};

export default Error;

const ErrorMessage = styled.div`
    text-align: center;
`;
